import styles from './SuccessFeedbackScreen.css';
import AppBar from '../AppBar/AppBar';
import Title from '../Typography/Title';
import InfoOutlinedIcon from '../Icons/InfoOutlinedIcon';
import BodyText from '../Typography/BodyText';
import Button from '../Button/Button';
import { renderIf } from '../../../utils/render.utils';
import List from '../List/List';
import ListItem from '../List/ListItem';

export default function SuccessFeedbackScreen({
  className = '',
  onCloseClick = null,
  image,
  title,
  text = '',
  subtitle = '',
  icon = null,
  list = [],
  ctaAction,
  ctaText,
  secondaryCtaAction,
  secondaryCtaText,
}) {
  return (
    <div className={`${className} ${styles.main}`}>
      <AppBar
        onCloseClick={onCloseClick}
        className={`fixed-bar ${styles['success-bg']}`}
      />

      <div className={styles.content}>
        <div className={styles['feedback-image']}>
          <img src={image} width={160} height={160} />
        </div>

        <div className={styles.text}>
          <div className={styles['feedback-title']}>
            <Title text={title} className="text-center" />
          </div>
          {renderIf(
            !!text,
            <div className={`${styles['feedback-text']}`}>
              <BodyText text={text} className="text-center" />
            </div>,
          )}
        </div>

        {renderIf(
          !!subtitle,
          <div className={styles['feedback-subtitle']}>
            <div className={styles['feedback-subtitle-icon-wrapper']}>
              {icon ? icon : <InfoOutlinedIcon />}
            </div>
            <BodyText
              className={styles['feedback-subtitle-text']}
              text={subtitle}
            />
          </div>,
        )}

        {renderIf(
          list && list.length > 0,
          <List className={styles.list}>
            {list.map((item, index) => (
              <ListItem
                key={index}
                className={styles['list-item']}
                subtitleClassName={styles['list-item-subtitle']}
                {...item}
              />
            ))}
          </List>,
        )}
      </div>
      <div className={`fixed-cta ${styles['bottom-container']}`}>
        <Button onClick={ctaAction} type={Button.Type.SECONDARY}>
          {ctaText}
        </Button>
        {secondaryCtaText && (
          <Button
            className={styles['secondary-button']}
            onClick={secondaryCtaAction}
            type={Button.Type.TERTIARY}
          >
            {secondaryCtaText}
          </Button>
        )}
      </div>
    </div>
  );
}
